import React from 'react'
import { H4, Image, P } from '../../../../../../AbstractElements';
import { currentCartTableBodyData } from '../../../../../../Data/Forms/FormLayoutData';
import { dynamicImage } from '../../../../../../Utils';

export default function CurrentCartTableBody() {
    return (
        <tbody>
            {currentCartTableBodyData.map((data, index) => (
                <tr key={index}>
                    <td>
                        <Image src={dynamicImage(data.imagePath)} alt="t-shirt" />
                    </td>
                    <td>
                        <div>
                            <H4>{data.productName}</H4>
                            <span>{data.productSum}</span>
                        </div>
                    </td>
                    <td>
                        <P>{data.price}</P>
                    </td>
                </tr>
            ))}
        </tbody>
    );
}
